import React from "react";

const GeneralQuestions = (props) => {
  const options = [
    {
      text: 'Qu\'est-ce que KONEK?',
      handler: props.actionProvider.handleGeneral1,
      id: 1,
    },
    {
      text: 'Qui dirige le service KONEK?',
      handler: props.actionProvider.handleGeneral2,
      id: 2
    },
    {
      text: 'Où puis-je payer avec KONEK?',
      handler: props.actionProvider.handleGeneral3,
      id: 3
    },
    {
      text: 'Qu\'est-ce qu\'un essai bêta?',
      handler: props.actionProvider.handleGeneral4,
      id: 4
    },
    {
      text: 'Quelles institutions financières offrent le service KONEK',
      handler: props.actionProvider.handleGeneral5,
      id: 5
    },
    {
      text: 'Comment puis-je m\'inscrire aux essais bêta de KONEK?',
      handler: props.actionProvider.handleGeneral6,
      id: 6
    },
    {
      text: 'e suis propriétaire d\'entreprise et j\'aimerais en savoir plus sur la participation aux essais bêta de KONEK. Avec qui puis-je communiquer?',
      handler: props.actionProvider.handleGeneral7,
      id: 7
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container'>{optionsMarkup}</div>;
};

export default GeneralQuestions;